import { render, staticRenderFns } from "./publicite.vue?vue&type=template&id=89a5f21e"
import script from "./publicite.vue?vue&type=script&lang=js"
export * from "./publicite.vue?vue&type=script&lang=js"
import style0 from "./publicite.vue?vue&type=style&index=0&id=89a5f21e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports